import { useState } from "react";
import ToggleMenu from "./toggle-menu";
const ToggleMenuStateContainer = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  return <ToggleMenu {...props} isOpen={isOpen} setIsOpen={setIsOpen} />;
};

export default ToggleMenuStateContainer;
